import Vue from 'vue'

import InputSuggestion from '@/components/base/input/InputSuggestion.vue'
import Suggestion from '@/components/base/input/Suggestion'

Vue.component(InputSuggestion.name, InputSuggestion)
Vue.component(Suggestion.name, Suggestion)
